/** @format */

import { Box } from '@mui/material';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

export default function PrintCaution({
  text = 'Privileged and confidential | Sharing this information could dilute your competitive advantage',
}) {
  return (
    <Box
      className="print-caution"
      sx={{
        display: 'none',

        '@media print': {
          display: 'flex',
          alignItems: 'center',

          position: 'static',

          width: '100%',
          boxSizing: 'border-box',

          marginTop: 'auto',
          paddingTop: '12px',

          fontFamily: '"Public Sans", sans-serif',
          fontSize: '8px',
          lineHeight: 1.2,

          color: '#7a7f87',

          whiteSpace: 'nowrap',

          breakInside: 'avoid',
          pageBreakInside: 'avoid',

          zIndex: 9999,
        },
      }}
    >
      <WarningAmberOutlinedIcon
        sx={{
          fontSize: '14px',
          mr: '4px',
          color: '#8b9098',
        }}
      />

      <Box component="span">{text}</Box>
    </Box>
  );
}
